import React from "react";
import { SearchMain } from "../components/Search";

const SearchPage = () => {
  return (
    <div>
      <SearchMain />
    </div>
  );
};

export default SearchPage;
